'use strict';

angular.module('shiftTraderApp')
  .directive('saNote', ['NotesStore', 'MediaStore', 'RecursionHelper', '$templateCache', '$compile', '$http', '$q', '$uibModal', function(NotesStore, MediaStore, RecursionHelper, $templateCache, $compile, $http, $q, $uibModal) {
    var baseTpl = '<div class="sa-note sa-note-view">' +
      '<div class="sa-note-inner">' +
      '<div class="sa-note-rerender-container"></div>' +
      '<div sa-note-replies ng-if="::!NoteCtrl.note.parent_id"></div>' +
      '</div>' +
      '</div>';


    function getTemplate(url) {
      var deferred = $q.defer();

      if ($templateCache.get(url)) {
        deferred.resolve($templateCache.get(url));
      } else {
        $http.get(url, {cache: true})
          .then(function(response) {
            $templateCache.put(url, response.data);
            deferred.resolve(response.data);
          }, function(response) {
            deferred.reject(response);
          });
      }

      return deferred.promise;
    }

    return {
      restrict: 'A',

      scope: {
        note: '=saNote'
      },
      bindToController: true,
      template: baseTpl,

      controllerAs: 'NoteCtrl',
      controller: ['$scope', function($scope) {
        var vm = this;
      }],
      compile: function(element) {
        function link(scope, elem, attrs, controller, transcludeFn) {
          var childScope;

          scope.state = {};

          function getMediaRecords() {
            scope.NoteCtrl.note._media = undefined;
            if (scope.NoteCtrl.note.media_ids && scope.NoteCtrl.note.media_ids.length > 0) {
              MediaStore.getMediaByIds(scope.NoteCtrl.note.media_ids)
                .then(function(mediaObjs) {
                  scope.NoteCtrl.note._media = mediaObjs;
                }, function(response) {
                  console.log('Failed to load Media records.', response);
                });
            }
          }
          getMediaRecords();

          if (scope.NoteCtrl.note.$isReply()) {
            $(elem).find('.sa-note').addClass('sa-note-is-reply');
          }

          var compileOpts = {
            transcludeControllers: {
              saNote: {instance: controller }
            }
          };

          function renderInner() {
            getMediaRecords();
            getTemplate('views/directives/notes/saNote.html')
              .then(function(templateString) {
                if (childScope) {
                  childScope.$destroy();
                }
                childScope = scope.$new();
                var x = $(elem).find('> .sa-note > .sa-note-inner > .sa-note-rerender-container');
                x.replaceWith($compile(templateString)(childScope, undefined, compileOpts));
              }, function() {

              });
          }



          scope.updateChannel = NotesStore.getUpdateChannelForNote(scope.NoteCtrl.note);

          var subscription = scope.updateChannel.subscribe(function(note) {

            // ????????
            scope.NoteCtrl.note.media_ids = note.media_ids;

            if (scope.NoteCtrl.note.updated_at !== note.updated_at) {
              note.$getPermissions()
                .then(function(permDict) {
                  scope.state.hasPermissions = true;
                });

              if (scope.NoteCtrl.note.id === note.id && _.isNull(note.deleted_at)) {
                scope.NoteCtrl.note = _.merge(scope.NoteCtrl.note, note);
                renderInner();
              } else if (scope.NoteCtrl.note.id === note.id && note.deleted_at) {
                scope.NoteCtrl.note = _.merge(scope.NoteCtrl.note, note);
                // if the note was just deleted
                $(elem).children('.sa-note').addClass('deleted');
              }
            }

          }, function(err) {
            console.log('err', err);
          });


          scope.NoteCtrl.note.$getPermissions()
            .then(function(permDict) {
              scope.state.permissions = permDict;
              scope.state.hasPermissions = true;
            });

          renderInner();

          scope.activateLightbox = function(currentMediaIndex) {
            var modalInstance = $uibModal.open({
              size: 'md',
              templateUrl: 'views/lightbox.html',
              controller: 'Lightbox',
              resolve: {
                params: function() {
                  return {
                    media: scope.NoteCtrl.note._media,
                    currentMediaIndex: currentMediaIndex
                  }
                }
              }
            });
          };

          scope.$on('$destroy', function() {
            console.log('$destroy -- saNote');
            subscription.dispose();
          })


        }
        return RecursionHelper.compile(element, link);
      }
    }
  }]);
